import { RequisiteName, RequisitesFieldName, RequisitesFormName } from 'utils/constants/requisites';

const getFieldPath = (fieldName: RequisiteName | RequisitesFieldName, formName?: RequisitesFormName): string => {
    if (!formName) return fieldName;
    return `${formName}.${fieldName}`;
};

export default getFieldPath;
